<template>
  <div>
    <div class="row my-1">
      <div class="offset-4 col-8 d-flex">
        <input v-model="startDate" class="form-control form-control-sm mx-2" type="date" />
        <input v-model="endDate" class="form-control form-control-sm mx-2" type="date" />
        <button
          @click="$parent.getBannerStats(startDate, endDate)"
          class="btn btn-sm btn-outline-info float-right mr-2"
        >Харах</button>
        <button
          @click="$parent.onDownloadExcel('banner_stat_excel', startDate, endDate)"
          class="btn btn-sm btn-outline-success"
        >Excel татах</button>
      </div>
    </div>
    <br />
    <div class="stat-table">
      <div class="banner_stat_table_container">
        <table class="table table-bordered banner_stat_table">
          <tbody>
            <tr>
              <th colspan="12" class="stat__title">www.u-money.mn сайтын баннерийн тайлан</th>
            </tr>
            <tr>
              <th rowspan="4"></th>
              <td rowspan="4">Баннер гарчиг</td>
              <td rowspan="3" colspan="3">Хугацаа</td>
              <td colspan="6">Баннер</td>
              <td rowspan="4">Баннер линк</td>
            </tr>
            <tr>
              <td colspan="3">Харсан</td>
              <td colspan="3">Дарсан</td>
            </tr>
            <tr>
              <td rowspan="2">Мобайл</td>
              <td rowspan="2">Веб</td>
              <th rowspan="2">Нийт</th>
              <td rowspan="2">Мобайл</td>
              <td rowspan="2">Веб</td>
              <th rowspan="2">Нийт</th>
            </tr>
            <tr>
              <td>Upload day</td>
              <td>Start day</td>
              <td>End day</td>
            </tr>
            <tr v-for="(stat, i) in bannerStats" :key="i">
              <td>{{ i + 1 }}</td>
              <th @click="goBannerDetail(stat.banner.id)" class="pointer">
                <a
                  target="_blank"
                  v-bind:href="'/stat/banner/' + stat.banner.id"
                >{{ stat.banner.name }}</a>
              </th>
              <td class="min_width-100">{{ stat.banner.created != null ? stat.banner.created : '-' }}</td>
              <td class="min_width-100">{{ stat.banner.startDate }}</td>
              <td class="min_width-100">{{ stat.banner.endDate }}</td>
              <td>{{ stat.viewMobile }}</td>
              <td>{{ stat.viewPc }}</td>
              <th>{{ stat.view }}</th>
              <td>{{ stat.clickMobile }}</td>
              <td>{{ stat.clickPc }}</td>
              <th>{{ stat.click }}</th>
              <td>
                <a
                  target="_blank"
                  v-bind:href="'/banner/edit/' + stat.banner.id"
                >{{ stat.banner.url != null ? stat.banner.url : "No URL"}}</a>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          v-if="bannerStat == null || bannerStats.length == 0"
          class="text-secondary text-center"
        >
          <i class="fas fa-exclamation-circle"></i>
          Өгөгдөл олдсонгүй
        </div>
        <br />
      </div>
    </div>
    <div class="text-center">{{ bannerStatDate }}</div>
  </div>
</template>

<style>
.banner_stat_table td,
th {
  font-size: 0.8em;
  text-align: center;
  vertical-align: middle !important;
}

.banner_stat_table_container {
  overflow-x: auto;
}

.banner_stat_table {
  width: auto;
  margin: auto
}

.pointer {
  cursor: pointer;
}

.min_width-100 {
  min-width: 100px;
}
</style>

<script>
export default {
  name: "BannerStatistic",

  props: ["bannerStat", "start", "end"],

  computed: {
    updated() {
      return `${this.bannerStat}|${this.start}|${this.end}`;
    }
  },

  watch: {
    bannerStat: function() {
      this.makeData();
    }
  },

  created() {
    this.makeData();
  },

  data() {
    return {
      bannerStats: null,
      bannerStatDate: "",

      startDate: this.start,
      endDate: this.end
    };
  },

  methods: {
    makeData() {
      this.bannerStats = this.bannerStat.stat;
      this.bannerStatDate =
        this.bannerStat.startDate + " - " + this.bannerStat.endDate;
    },

    goBannerDetail(id) {
      this.$router.push({ name: "BannerStatDetail" });
      let routeData = this.$router.resolve({
        name: "BannerStatDetail",
        params: { id: id }
      });
      window.open(routeData.href, "_blank");
    }
  }
};
</script>